import loadable from '@loadable/component';

export const LvgSiteWrapper = loadable(
  () => import(/* webpackChunkName: "lvg-site" */ './LvgSiteWrapper'),
);
